import { render, staticRenderFns } from "./ItemIndexFilterNotification.vue?vue&type=template&id=0ccdebab"
import script from "./ItemIndexFilterNotification.vue?vue&type=script&lang=js"
export * from "./ItemIndexFilterNotification.vue?vue&type=script&lang=js"
import style0 from "./ItemIndexFilterNotification.vue?vue&type=style&index=0&id=0ccdebab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports